// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-product-bottom-sheet {
  /* Override bottom sheet styles for this specific component */
}

.add-product-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 0 16px;
  overflow: hidden;
}

/* Search stays visible; fixed height so it never gets pushed out */
.search-section {
  flex-shrink: 0;
  margin-bottom: 16px;
  padding: 16px 0;
  border-bottom: 1px solid var(--color-light-gray);
}

.search-input-container {
  width: 100%;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background-color: var(--color-light-gray);
  border-radius: 8px;
  padding: 0 12px;
  border: 1px solid transparent;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  min-height: 44px;
  box-sizing: border-box;
}

.search-input-wrapper:focus-within {
  border-color: var(--color-primary-green);
  box-shadow: 0 0 0 2px var(--accent-ring);
}

/* Fixed-width slots so input doesn't shift when icon/button toggle */
.search-icon-slot,
.search-clear-slot {
  width: 32px;
  min-width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.search-icon-slot {
  color: var(--color-dark-gray);
}

.search-input-field {
  flex: 1;
  border: none;
  background: none;
  padding: 0 8px;
  font-size: 16px;
  color: var(--color-black);
  outline: none;
  font-family: inherit;
  text-align: left;
  min-width: 0;
}

.search-input-field::placeholder {
  color: var(--color-dark-gray);
}

.clear-search-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-dark-gray);
  transition: background-color 0.2s ease;
}

.clear-search-button:hover {
  background-color: var(--color-gray);
}

.products-list {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px 0;
  min-height: 0;
  -webkit-overflow-scrolling: touch;
}

.add-product-loading {
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
}



.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 16px;
  gap: 12px;
  color: var(--color-gray);
  text-align: center;
}

.add-product-footer {
  display: flex;
  gap: 12px;
  padding: 16px 0;
  border-top: 1px solid var(--color-light-gray);
  margin-top: auto;
  flex-shrink: 0;
}

.cancel-button,
.add-button {
  flex: 1;
  height: 48px;
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .add-product-content {
    padding: 0 12px;
  }
  
  .search-section {
    padding: 12px 0;
  }
  
  .add-product-footer {
    padding: 12px 0;
    gap: 8px;
  }
  
  .cancel-button,
  .add-button {
    height: 44px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/bottomdrawers/AddProductBottomSheet.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,wDAAwD;EACxD,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA,qEAAqE;AACrE;;EAEE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,6CAA6C;EAC7C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,OAAO;EACP,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;;IAEE,YAAY;EACd;AACF","sourcesContent":[".add-product-bottom-sheet {\n  /* Override bottom sheet styles for this specific component */\n}\n\n.add-product-content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  padding: 0 16px;\n  overflow: hidden;\n}\n\n/* Search stays visible; fixed height so it never gets pushed out */\n.search-section {\n  flex-shrink: 0;\n  margin-bottom: 16px;\n  padding: 16px 0;\n  border-bottom: 1px solid var(--color-light-gray);\n}\n\n.search-input-container {\n  width: 100%;\n}\n\n.search-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  background-color: var(--color-light-gray);\n  border-radius: 8px;\n  padding: 0 12px;\n  border: 1px solid transparent;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  min-height: 44px;\n  box-sizing: border-box;\n}\n\n.search-input-wrapper:focus-within {\n  border-color: var(--color-primary-green);\n  box-shadow: 0 0 0 2px var(--accent-ring);\n}\n\n/* Fixed-width slots so input doesn't shift when icon/button toggle */\n.search-icon-slot,\n.search-clear-slot {\n  width: 32px;\n  min-width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.search-icon-slot {\n  color: var(--color-dark-gray);\n}\n\n.search-input-field {\n  flex: 1;\n  border: none;\n  background: none;\n  padding: 0 8px;\n  font-size: 16px;\n  color: var(--color-black);\n  outline: none;\n  font-family: inherit;\n  text-align: left;\n  min-width: 0;\n}\n\n.search-input-field::placeholder {\n  color: var(--color-dark-gray);\n}\n\n.clear-search-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-dark-gray);\n  transition: background-color 0.2s ease;\n}\n\n.clear-search-button:hover {\n  background-color: var(--color-gray);\n}\n\n.products-list {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 8px 0;\n  min-height: 0;\n  -webkit-overflow-scrolling: touch;\n}\n\n.add-product-loading {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 0;\n}\n\n\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 16px;\n  gap: 12px;\n  color: var(--color-gray);\n  text-align: center;\n}\n\n.add-product-footer {\n  display: flex;\n  gap: 12px;\n  padding: 16px 0;\n  border-top: 1px solid var(--color-light-gray);\n  margin-top: auto;\n  flex-shrink: 0;\n}\n\n.cancel-button,\n.add-button {\n  flex: 1;\n  height: 48px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 480px) {\n  .add-product-content {\n    padding: 0 12px;\n  }\n  \n  .search-section {\n    padding: 12px 0;\n  }\n  \n  .add-product-footer {\n    padding: 12px 0;\n    gap: 8px;\n  }\n  \n  .cancel-button,\n  .add-button {\n    height: 44px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
